var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.trust ? _c('div', {
    staticClass: "col-lg-8 col-md-8 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0"
  }, [_vm.trust && [0, 1, 2].includes(_vm.trust.status) && !_vm.amendmentId || _vm.amendment && [0, 1, 2].includes(_vm.amendment.status) && _vm.amendmentId ? _c('editable-part-d', {
    attrs: {
      "trust": _vm.hibah
    }
  }) : _vm._e(), _vm.trust && ![0, 1, 2].includes(_vm.trust.status) && !_vm.amendmentId || _vm.amendment && ![0, 1, 2].includes(_vm.amendment.status) && _vm.amendmentId ? _c('readonly-part-d', {
    attrs: {
      "trust": _vm.hibah
    }
  }) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }